export default {
  exceedMaximumUserInviteLimitation: 400001,
};
